import Display from '@/assets/icons/ui/display.svg?react'
import Images from '@/assets/icons/ui/images.svg?react'
import Logout from '@/assets/icons/ui/logout.svg?react'
import Repeat from '@/assets/icons/ui/repeat.svg?react'
import useAuthStore from '@/store/userStore'

const logoutFunction = useAuthStore.getState().logout

export const NAV_LINKS = [
  {
    name: 'Wygeneruj',
    path: '/',
    icon: Repeat
  },
  {
    name: 'Zapisane grafiki',
    path: '/grafiki',
    icon: Images
  },
  {
    name: 'Lista wyświetlaczy',
    path: '/wyswietlacze',
    icon: Display
  },
  {
    name: '',
    onClick: () => logoutFunction(),
    icon: Logout
  }
]
